<template>
  <div>
    <map-component
      :center="center"
      :markers="markersList"
      :controls="!isTileList"
      @setActive="handleSetActive"
      @mount="handleMapMount"
    />
    <transition name="fade-up">
      <tile-list
        v-if="isTileList"
        :places="tileList"
        @setActive="handleSetActive"
      />
    </transition>
    <tile-list-close
      v-if="isTileList"
      @click="toggleMode"
    />
    <switcher-component :type="mode" @click="switchMode"/>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
import { TOGGLE_MODE, SET_MAP_LOADED } from '@/store/mutation-types'

import { MAP_CONFIG } from '@/assets/js/map'
import fetchLocation from '@/assets/js/map/fetchLocation'
import isMobile from '@/assets/js/isMobile'

import MapComponent from '@/containers/Map/Map'
import TileList from '@/containers/Map/TileList'
import SwitcherComponent from '@/containers/Map/Switcher'
import TileListClose from '@/containers/Map/TileListClose'

export default {
  components: {
    MapComponent,
    TileList,
    SwitcherComponent,
    TileListClose
  },
  data () {
    return {
      center: MAP_CONFIG.center,
      restoreTiles: false
    }
  },
  computed: {
    ...mapState(['isAnimationComplete']),
    ...mapGetters(['places', 'isTileList', 'mode']),
    tileList () {
      return isMobile.any()
        ? this.places.filter(place => place.visible).slice(0, 32)
        : this.places.filter(place => place.visible).slice(0, 64)
    },
    markersList () {
      return !this.isTileList || isMobile.any()
        ? this.places
        : this.places.map(place => ({ ...place, visible: false }))
    }
  },
  watch: {
    $route () {
      const { name, params } = this.$route
      if (name === 'details') {
        if (this.isTileList) {
          this.restoreTiles = true
          this.toggleMode()
        }

        this.setActivePlace(params.id)
      } else {
        if (this.restoreTiles) {
          this.toggleMode()
          this.restoreTiles = false
        }

        this.clearActivePlace()
      }
    },
    isAnimationComplete () {
      if (this.isAnimationComplete) {
        this.fetchPlacesList()
      }
    }
  },
  created () {
    fetchLocation()
      .then(this.setCenter)

    if (this.$route.name === 'details') {
      this.clearActivePlace()
    }
  },
  methods: {
    ...mapActions(['fetchPlacesList', 'setActivePlace']),
    ...mapMutations({ toggleMode: TOGGLE_MODE, setMapLoaded: SET_MAP_LOADED }),
    handleSetActive (id) {
      if (id === -1) {
        this.$router.push({ name: 'map' })
        return
      }

      this.setActivePlace(id)
    },
    handleMapMount () {
      // TODO: Add real Google maps callback
      setTimeout(() => {
        this.setMapLoaded()
      }, 1200)
    },
    setCenter (coords) {
      this.center = coords
    },
    clearActivePlace () {
      this.$route.name === 'map' && this.setActivePlace(-1)
    },
    switchMode () {
      if (this.$route.name !== 'map') {
        this.handleSetActive(-1)
      }
      this.toggleMode()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Map/MapContainer.vue